__turbopack_context__.v({
  "circle": "stepsSection-module-scss-module__GC0fWW__circle",
  "clickable": "stepsSection-module-scss-module__GC0fWW__clickable",
  "container": "stepsSection-module-scss-module__GC0fWW__container",
  "elevated": "stepsSection-module-scss-module__GC0fWW__elevated",
  "heading": "stepsSection-module-scss-module__GC0fWW__heading",
  "highlighted": "stepsSection-module-scss-module__GC0fWW__highlighted",
  "icon": "stepsSection-module-scss-module__GC0fWW__icon",
  "iconWrapper": "stepsSection-module-scss-module__GC0fWW__iconWrapper",
  "responsive": "stepsSection-module-scss-module__GC0fWW__responsive",
  "step": "stepsSection-module-scss-module__GC0fWW__step",
  "stepBulletpoint": "stepsSection-module-scss-module__GC0fWW__stepBulletpoint",
  "stepContent": "stepsSection-module-scss-module__GC0fWW__stepContent",
  "stepDescription": "stepsSection-module-scss-module__GC0fWW__stepDescription",
  "stepName": "stepsSection-module-scss-module__GC0fWW__stepName",
  "steps": "stepsSection-module-scss-module__GC0fWW__steps",
});
